import { I18n } from "@assets/strings";
import React from "react";
import styled from "styled-components";
import { GroupMemberRole } from "@domain/group/group";
import { FilterIcon } from "@ui/components/icons";
import { row } from "@ui/components/layout";
import { Menu } from "@ui/components/menus/menu";
import { gap } from "@ui/styles/utils";

interface ShareroomRoleFilterProps extends React.HTMLAttributes<HTMLDivElement> {
	memberRole: GroupMemberRole | "ALL";
	onRoleChange: (newRole: GroupMemberRole | "ALL") => void;
}
export const ShareroomRoleFilter: React.FC<ShareroomRoleFilterProps> = ({ memberRole, onRoleChange, ...htmlProps }) => {
	return (
		<Menu
			bottomSheetMode
			closeOnSelect
			align="left"
			{...htmlProps}
			renderMenuContent={() => (
				<Content>
					{(["MEMBER", "ADMINISTRATOR", "ALL"] as const).map((memberRole) => (
						<Row key={memberRole} status={memberRole} onClick={() => onRoleChange(memberRole)}>
							• {I18n.t(`shareroom.role.${memberRole}`)}
						</Row>
					))}
				</Content>
			)}
		>
			<MenuLayout>
				<FilterIcon />
				<div>{I18n.t(`shareroom.role.${memberRole}`)}</div>
			</MenuLayout>
		</Menu>
	);
};

const MenuLayout = styled.div`
	${({ theme }) => theme.textStyles.primary};
	${row(8, "center")}
`;
const Content = styled.div`
	display: flex;
	flex-direction: column;
	${gap(20)}
	white-space: nowrap;
`;

const Row = styled.div.withConfig({
	shouldForwardProp: (prop) => prop !== "status",
})<{ status: GroupMemberRole | "ALL" }>`
	cursor: pointer;
`;
